import React, { useEffect } from "react";
import { useLocation, useParams } from "react-router-dom";

import { useSnowplowContext } from "supercell-frontend-base/src/analytics/snowplow";

import { filterLiveArticles } from "supercell-frontend-base/src/utils/targeting/filter-live-articles";

import { CommunityView } from "./view";

export const CommunityController = () => {
    const loc = useLocation();
    const { type } = useParams();
    const { pathname: pagePath } = loc;

    const isMegaCrabPage = type && type.toLowerCase() === "megacrab";
    const { trackPageView } = useSnowplowContext();

    useEffect(() => {
        trackPageView("Community", pagePath);

        window.history.pushState({ home: true }, "");
    }, []);

    return (
        <CommunityView
            filterArticles={filterLiveArticles}
            isMegaCrabPage={isMegaCrabPage}
        />
    );
};
